export default __webpack_public_path__ + "static/media/black-compass.86d97b0f.svg";